   
import type { Money } from "@frontend/walletapi";
import { format } from "date-fns";

export function formatCount(count: number | undefined | null): string {
    if (!count)
    {
        return "0";
    }

    return count.toLocaleString('en-US', {});
}

export function formatCount2(count: number | undefined | null): string {
    if (!count)
    {
        count = 0;
    }

    return count.toString();
}

export function formatMoney(cents: Money | number | undefined | null): string
{
    let n = 0;

    if (typeof cents == "number")
    {
        n = cents;
    }
    else if (!cents)
    {
        // format missing as 0
        return "";
    }
    else
    {
        n = cents.InCents;
    }
    
    n = n / 100;
    
    return n.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function formatDateOnly(datetime: Date | undefined)
{
    if (!datetime)
    {
        return "";
    }
    
    let parsedDate: Date | undefined = undefined;
    if (typeof datetime == "string")
    {
        parsedDate = new Date(datetime);
    }
    else if (datetime instanceof Date)
    {
        parsedDate = datetime;
    }

    if (!parsedDate)
    {
        return "";
    }

    return format(parsedDate, "MMM-dd-yyyy");
}

export function formatTimeOnly(datetime: Date | string | number | undefined)
{
    if (!datetime)
    {
        return "";
    }

    let parsedDate: Date | undefined = undefined;
    if (typeof datetime == "string")
    {
        parsedDate = new Date(datetime);
    }
    else if (datetime instanceof Date)
    {
        parsedDate = datetime;
    }

    if (!parsedDate)
    {
        return "";
    }

    return format(parsedDate, "hh:mm:ss aaaa")
}

export function formatDateTime(datetime: Date | undefined)
{
    if (!datetime)
    {
        return "";
    }

    let parsedDate: Date | undefined = undefined;
    if (typeof datetime == "string")
    {
        parsedDate = new Date(datetime);
    }
    else if (datetime instanceof Date)
    {
        parsedDate = datetime;
    }

    if (!parsedDate)
    {
        return "";
    }

    let formattedDate = format(parsedDate, "MMM-dd-yyyy hh:mm:ss aaaa");

    return formattedDate;
}

 export function formatDate(dateStr: string | number | Date) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    // Obtener año, mes y día en formato correcto
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }